import { Stack } from "@sveabank/cc-common";
import { useSignInformation } from "../../features/sign-page/hooks/hooks";
import { usePageContext } from "../../hooks/context";
import InformationSection from "./information-section";
import ProductSection from "./product-section";

const ReviewSection = () => {
	const { applicationDetails, applicantContactInfo, organizationContactInfo, selectedPackageData } =
		usePageContext(useSignInformation);

	return (
		<Stack gap={4}>
			<InformationSection
				details={applicationDetails}
				applicantInfo={applicantContactInfo}
				companyInfo={organizationContactInfo}
			/>
			<ProductSection selectedPackage={selectedPackageData} />
		</Stack>
	);
};

export default ReviewSection;
